<template>
  <div>
    <!-- {{ maquinas }} -->
    <v-card elevation="0">
      <v-card-title class="mt-6 ml-6">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <!-- MÁQUINA: {{ getMachine.maquina?getMachine.maquina.toUpperCase():null }} -->
            <v-select
              class="pt-0"
              prefix="MÁQUINA: "
              v-model="maquinaSeleccionada"
              placeholder="Seleccionar máquina..."
              :items="maquinas_posibles"
              color="primary"
            >
            </v-select>
          </v-col>
          <!-- {{ getMachine }} -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            v-if="
              maquinaSeleccionada == 'MACHERIA' ||
              maquinaSeleccionada == 'MOLDEO'
            "
          >
            <v-card-text
              style="font-weight: 450; font-size: 80%"
              class="pl-0 pt-2"
              >PIEZA:
              {{
                getMachine.pieza
                  ? getMachine.pieza.toUpperCase()
                  : "NO RELLENADO"
              }}</v-card-text
            >
          </v-col>
          <v-col v-if="maquinaSeleccionada" cols="12" sm="12" xs="12" md="4">
            <v-card-text class="pl-0 pt-2"
              >Última lectura de datos:
              {{
                getMachine.maquina == "desmoldeo"
                  ? ultima_lectura_desmoldeo
                  : getMachine.maquina == "macheria"
                  ? ultima_lectura_macheria
                  : ultima_lectura_moldeo
              }}</v-card-text
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text v-if="maquinaSeleccionada == 'DESMOLDEO'">
        <v-row>
          <v-col>
            <v-btn block @click="setMode(1)">TIEMPO REAL</v-btn>
          </v-col>
          <v-col>
            <v-btn block @click="setMode(2)">PARRILLA 1</v-btn>
          </v-col>
          <v-col>
            <v-btn block @click="setMode(3)">PARRILLA 2</v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <!--  GRID con el valor de cada variable -->
      <v-container fluid>
        <!-- AVISO DE QUE LOS DATOS QUE SE VEN NO SE ESTAN HISTORIZANDO YA QUE NO HAY CICLO EN MARCHA -->
        <v-row
          v-if="maquinaSeleccionada != 'DESMOLDEO' && check_historizando()"
        >
          <v-col cols="12">
            <v-alert dense type="info" color="primary">
              Los datos que se muestran
              <strong>NO SE ESTÁN HISTORIZANDO</strong> porque la máquina no
              está en marcha.
            </v-alert>
          </v-col>
        </v-row>
        <!-- Cajas de tiempo real -->
        <v-row dense v-if="mode == 1">
          <v-col
            v-for="variable in current_data"
            :key="variable.id_variable"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="10" class="mt-2">
                    {{ variable.variable }}: {{ valor_calculado(variable) }}
                    <!-- <hr> {{ variable }} -->
                  </v-col>
                  <v-col cols="1" class="text-right">
                    <v-btn icon @click="mostrarGraficaTiempoReal(variable)">
                      <v-icon> mdi-finance </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense v-if="mode == 2">
          <v-alert dense type="success" style="width: 100%">
            Parrilla 1
          </v-alert>
          <ParrillaComponent :data="datos_parrillas_1" :parrilla="1" />
        </v-row>
        <v-row dense v-if="mode == 3">
          <v-alert dense type="success" style="width: 100%">
            Parrilla 2
          </v-alert>
          <ParrillaComponent :data="datos_parrillas_2" :parrilla="2" />
        </v-row>
      </v-container>
    </v-card>

    <GraficoTiempoReal
      @cerrar="cerrar()"
      :mostrar="mostrandoGraficaEnTiempoReal"
      :dialogTitle="graficaDialogTitle"
      :datos_grafico="datosTiempoReal"
    />
  </div>
</template>
<script>
import GraficoTiempoReal from "@/components/GraficoTiempoReal.vue";
import ParrillaComponent from "@/components/ParrillaComponent.vue";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "HomeView",
  components: {
    GraficoTiempoReal,
    ParrillaComponent,
  },
  data() {
    return {
      mode: 1,
      maquinaSeleccionada: null,
      mostrandoGraficaEnTiempoReal: false,
      graficaDialogTitle: null,
      // maquinas_posibles:['desmoldeo','macheria','moldeo']
      variable_tiempo_real: {},
    };
  },

  mounted() {
    if (this.getMachine.maquina && !this.getMachine.maquina.includes("horno "))
    // if (this.getMachine.maquina)
      this.maquinaSeleccionada = this.getMachine.maquina.toUpperCase();
  },
  watch: {
    maquinaSeleccionada() {
      if (this.maquinaSeleccionada != this.getMachine.maquina.toUpperCase()) {
        this.setMachine(this.maquinaSeleccionada.toLowerCase());
      }
    },
  },

  computed: {
    ...mapState([
      "maquinas",
      "datosTiempoReal",
      "ultima_lectura_desmoldeo",
      "ultima_lectura_moldeo",
      "ultima_lectura_macheria",
      "graficoTiempoReal",
      "datasetsParaGrafico",
      "labelsParaGrafico",
      "datos_maquina",
      "datos_parrillas_1",
      "datos_parrillas_2",
    ]),
    ...mapGetters(["getMachine"]),
    maquinas_posibles() {
      const nombres = Object.keys(this.datos_maquina);
      return nombres.map((e) => e.toUpperCase());
      // return Object.keys(this.datos_maquina)
    },

    current_data() {
      // let salida=null;
      if (this.maquinaSeleccionada) {
        let variables =
          this.datos_maquina[this.maquinaSeleccionada.toLowerCase()];
        return variables.filter((e) => !e.es_alarma);
      } else return null;
    },

    ////grafica en tiempo real////
    datosTiempoReal() {
      return {
        labels: this.labelsParaGrafico,
        datasets: this.datasetsParaGrafico,
      };
    },
  },
  methods: {
    ...mapActions([
      "setMachine",
      "setPieza",
      "setShowChart",
      "setVariableEnGrafica",
      "limpiarGrafico",
    ]),
    setMode(v) {
      this.mode = v;
    },
    check_historizando() {
      if (this.current_data) {
        const variable_estado = this.current_data.find(
          (c) => c["memoria"] == "DB130.DBX96.0"
        );
        try {
          return variable_estado.valor == 0;
        } catch (error) {
          // console.log(variable_estado, error);
        }
      } else {
        return false;
      }
    },
    valor_calculado(v) {
      try {
        let valor_actual = v.valor * v.escala;
        let salida = valor_actual.toFixed(v.decimales);
        return salida;
      } catch (error) {
        return `err: ${v.valor}`;
      }
    },

    mostrarGraficaTiempoReal(elemento) {
      this.setVariableEnGrafica(elemento.id_variable);
      this.mostrandoGraficaEnTiempoReal = true;
      this.graficaDialogTitle = elemento.variable;
    },
    cerrar() {
      this.mostrandoGraficaEnTiempoReal = false;
      this.limpiarGrafico();
    },
  },
};
</script>
<style>
.chart-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  /* Para centrar horizontalmente */
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
}
</style>
